// 管理员 mock 数据

export const defaultAdmins = [
  {
    admin_id: 1,
    email: 'admin@admin.com',
    real_name: '系统管理员',
    role: 'super_admin',
    password: 'admin123',
    permissions: [],
    data_scope: 'all',
    scope_departments: [],
    status: 1,
    created_at: '2023-01-01'
  },
  {
    admin_id: 2,
    email: 'hr@company.com',
    real_name: 'HR专员',
    role: 'admin',
    password: 'hr123',
    permissions: [
      'employee:view', 'employee:edit', 'employee:import',
      'evaluation:view',
      'behavior:view',
      'departure_feedback:view',
      'survey:view'
    ],
    data_scope: 'all',
    scope_departments: [],
    task_ids: [1],
    status: 1,
    created_at: '2023-06-01'
  },
  {
    admin_id: 3,
    email: 'dept_mgr@company.com',
    real_name: '部门主管',
    role: 'admin',
    password: 'mgr123',
    permissions: ['employee:view', 'case:view'],
    data_scope: 'self',
    scope_departments: [],
    task_ids: [1, 2],
    status: 1,
    created_at: '2023-09-01'
  }
]
